import FooterComponent from "../../components/FooterComponent.vue";
import NavBar from "../../components/NavBar.vue";
import SideBar from "../../components/SideBar.vue";
import Login from "../../layout/Login.vue";
import CompaniesAdd from "../../views/companies/CompaniesAdd.vue";
import CompaniesList from "../../views/companies/CompaniesList.vue";
import Home from "../../views/Home.vue";
import InvoiceAdd from "../../views/invoice/InvoiceAdd.vue";
import Profile from "../../views/Profile.vue";
import Users from "../../views/Users.vue";
import UsersAdd from "../../views/UsersAdd.vue";
import store from "../../store";

const AdminRoutes = [
  {
    path: "/:prefix/login",
    name: "login-prefix",
    meta: {
      public: true
    },
    components: {
      default: Login,
      footer: FooterComponent
    }
  },
  {
    path: "/login",
    name: "login",
    meta: {
      public: true
    },
    components: {
      default: Login,
      footer: FooterComponent
    }
  },

  {
    path: "/:prefix/home",
    name: "home",
    meta: {
      public: false
    },
    components: {
      menu: SideBar,
      header: NavBar,
      default: Home,
      footer: FooterComponent
    }
  },
  {
    path: "/home",
    redirect: {
      name: "home",
      params: { prefix: store.state.auth.prefixRoute || "triyo" }
    }
  },

  {
    path: "/:prefix/perfil",
    name: "profile",
    meta: {
      public: false
    },
    components: {
      menu: SideBar,
      header: NavBar,
      default: Profile,
      footer: FooterComponent
    }
  },
  {
    path: "/perfil",
    redirect: {
      name: "profile",
      params: { prefix: store.state.auth.prefixRoute || "triyo" }
    }
  },

  {
    path: "/:prefix/empresa",
    name: "company",
    meta: {
      public: false,
      admin: true,
      master: true
    },
    components: {
      menu: SideBar,
      header: NavBar,
      default: CompaniesList,
      footer: FooterComponent
    }
  },
  {
    path: "/empresa",
    redirect: {
      name: "company",
      params: { prefix: store.state.auth.prefixRoute || "triyo" }
    }
  },

  {
    path: "/:prefix/empresa/adicionar",
    name: "company.add",
    meta: {
      public: false,
      admin: true,
      master: true
    },
    components: {
      menu: SideBar,
      header: NavBar,
      default: CompaniesAdd,
      footer: FooterComponent
    }
  },
  {
    path: "/empresa/adicionar",
    redirect: {
      name: "company.add",
      params: { prefix: store.state.auth.prefixRoute || "triyo" }
    }
  },

  {
    path: "/:prefix/empresa/adicionar/:id",
    name: "company.edit",
    meta: {
      public: false,
      admin: true,
      master: true
    },
    components: {
      menu: SideBar,
      header: NavBar,
      default: CompaniesAdd,
      footer: FooterComponent
    }
  },
  {
    path: "/empresa/adicionar/:id",
    redirect: {
      name: "company.edit",
      params: { prefix: store.state.auth.prefixRoute || "triyo" }
    }
  },

  {
    path: "/:prefix/usuario",
    name: "user",
    meta: {
      public: false,
      admin: true
    },
    components: {
      menu: SideBar,
      header: NavBar,
      default: Users,
      footer: FooterComponent
    }
  },
  {
    path: "/usuario",
    redirect: {
      name: "user",
      params: { prefix: store.state.auth.prefixRoute || "triyo" }
    }
  },

  {
    path: "/:prefix/usuario/adicionar",
    name: "user.add",
    meta: {
      public: false,
      admin: true
    },
    components: {
      menu: SideBar,
      header: NavBar,
      default: UsersAdd,
      footer: FooterComponent
    }
  },
  {
    path: "/usuario/adicionar",
    redirect: {
      name: "user.add",
      params: { prefix: store.state.auth.prefixRoute || "triyo" }
    }
  },

  {
    path: "/:prefix/usuario/adicionar/:id",
    name: "user.edit",
    meta: {
      public: false,
      admin: true
    },
    components: {
      menu: SideBar,
      header: NavBar,
      default: UsersAdd,
      footer: FooterComponent
    }
  },
  {
    path: "/usuario/adicionar/:id",
    redirect: {
      name: "user.edit",
      params: { prefix: store.state.auth.prefixRoute || "triyo" }
    }
  },

  {
    path: "/:prefix/nota/adicionar",
    name: "invoice.add",
    meta: {
      public: false,
      admin: true
    },
    components: {
      menu: SideBar,
      header: NavBar,
      default: InvoiceAdd,
      footer: FooterComponent
    }
  },
  {
    path: "/nota/adicionar",
    redirect: {
      name: "invoice.add",
      params: { prefix: store.state.auth.prefixRoute || "triyo" }
    }
  },

  {
    path: "/:prefix/nota/adicionar/:id",
    name: "invoice.edit",
    meta: {
      public: false,
      admin: true
    },
    components: {
      menu: SideBar,
      header: NavBar,
      default: InvoiceAdd,
      footer: FooterComponent
    }
  },
  {
    path: "/nota/adicionar/:id",
    redirect: {
      name: "invoice.edit",
      params: { prefix: store.state.auth.prefixRoute || "triyo" }
    }
  },

  {
    path: "/",
    redirect: {
      name: "home",
      params: {
        prefix:
          store.state.auth.prefixRoute ||
          localStorage.getItem("prefixRoute") ||
          "triyo"
      }
    }
  }
];

export default AdminRoutes;
